/**
 * Generated by `scripts/sync-monaco-assets.mjs`; do not edit by hand.
 * The editor loads from this same-origin path (`PG-PWA01`, ADR-0052).
 */
export const MONACO_VERSION = "0.55.1";
export const MONACO_VS_PATH = "/monaco/0.55.1/vs";
